import React, { useEffect, useState } from 'react';

import { FacturacionNru } from './FacturacionNru';
import instanciaAxios from '../../servicios/InterceptorAxios';

const titulo = "Servicio de facturación sin registro en línea del tramo carretero Guadalajara - Colima";

export const FacturacionSinRegistro = () => {

    const [autenticado,setAutenticado]=useState(false);    
    useEffect(() => {
        localStorage.removeItem("auth");
        instanciaAxios.post('/sinregistro/autenticar_invitado').then(response => {
            let token = response.headers['authorization'];
            token = token.replace("Bearer ", "");
            localStorage.setItem('auth', token);
            let tokenUUID = localStorage.getItem("token_gc");
            if (!tokenUUID) {
                instanciaAxios.post('/sinregistro/identificador.json').then(responseI => {
                    localStorage.setItem('token_gc', responseI.data);
                }).catch(error => {
    
                });
            }
            setTimeout(() => {
                setAutenticado(true);    
            }, 200);
        }).catch(response => {

        });
    },[]);
    
    const urlConsultaUsoCfdi='sinregistro/usocfdi40/obtener_usoscfdi_por_rfc.json';
    const urlConsultaRegimen="sinregistro/regimen/sinregistro_obtener_por_usocfdi_rfc.json";   
    const urlValidacionNru='sinregistro/cruce/validarCruceSinRegistro.json';
    const urlConsultaNru='sinregistro/cruce/buscarCrucesSinRegistro.json';
    const urlEliminarCruces='sinregistro/cruce/eliminarCruceSinRegistro.json';
    const urlGenerarFactura='sinregistro/cruce/generarFacturaSinRegistro.json';
    const urlValicacionReceptor='sinregistro/receptor/validacion/validar_receptor40.json';
    const urlDescargaArchivos ='sinregistro/cfdi/descargarzip.json';
    return (<div>
        <div className="p-fluid">
           <FacturacionNru titulo={titulo} urlConsultaUsoCfdi={urlConsultaUsoCfdi}
           urlConsultaRegimen={urlConsultaRegimen} urlValidacionNru={urlValidacionNru} urlConsultaNru={urlConsultaNru}
           autenticado={autenticado} urlEliminarCruces={urlEliminarCruces} urlGenerarFactura={urlGenerarFactura}
           urlValicacionReceptor={urlValicacionReceptor} urlDescargaArchivos={urlDescargaArchivos} />
        </div>
    </div>);
}